// Thin wrapper around Stripe client calls so we can mock behavior in tests
// without needing to type into Stripe iframes. In production this delegates
// to the provided stripe instance.

let testStripeClient = null;

export const __setTestStripeClient = (client) => {
  testStripeClient = client;
};

const inferDefaultReturnUrl = () => {
  if (typeof window !== 'undefined' && window?.location) {
    const { origin, pathname } = window.location;
    const safeOrigin = origin || 'https://localhost:3000';
    const safePath = pathname && pathname.startsWith('/') ? pathname : '/checkout';
    return `${safeOrigin}${safePath}`;
  }
  return 'https://localhost:3000/checkout';
};

export async function confirmSetupWithClient(stripe, elements, options = {}) {
  const client = testStripeClient || stripe;
  if (!client) {
    throw new Error('Stripe is not ready');
  }

  if (options.cardElement && typeof client.confirmCardSetup === 'function') {
    const clientSecret =
      options.clientSecret ||
      options.setupIntentClientSecret ||
      options.confirmClientSecret;
    if (!clientSecret) {
      throw new Error('Setup confirmation requires a client secret.');
    }

    const confirmData = {
      ...(options.confirmParams || {}),
      payment_method: {
        card: options.cardElement,
        ...(options.billingDetails ? { billing_details: options.billingDetails } : {}),
      },
    };

    if (!confirmData.return_url) {
      confirmData.return_url = inferDefaultReturnUrl();
    }

    return client.confirmCardSetup(clientSecret, confirmData);
  }

  if (typeof client.confirmSetup !== 'function') {
    throw new Error('Stripe is not ready');
  }

  const confirmParams = {
    ...(options.confirmParams || {}),
  };
  if (!confirmParams.return_url) {
    confirmParams.return_url = inferDefaultReturnUrl();
  }
  return client.confirmSetup({
    ...options,
    ...(elements ? { elements } : {}),
    confirmParams,
  });
}

export async function confirmPaymentWithClient(stripe, elements, options = {}) {
  const client = testStripeClient || stripe;
  if (!client) {
    throw new Error('Stripe is not ready');
  }

  const confirmParams = {
    ...(options.confirmParams || {}),
  };
  if (!confirmParams.return_url) {
    confirmParams.return_url = inferDefaultReturnUrl();
  }

  if (elements && typeof client.confirmPayment === 'function') {
    return client.confirmPayment({
      elements,
      ...options,
      confirmParams,
    });
  }

  if (typeof client.confirmCardPayment === 'function') {
    const clientSecret =
      options.clientSecret ||
      options.paymentIntentClientSecret ||
      options.confirmClientSecret;
    if (!clientSecret) {
      throw new Error('Payment confirmation requires a client secret.');
    }

    const confirmData = {
      ...confirmParams,
      ...(options.cardElement ? {
        payment_method: {
          card: options.cardElement,
          ...(options.billingDetails ? { billing_details: options.billingDetails } : {}),
        },
      } : {}),
    };

    return client.confirmCardPayment(clientSecret, confirmData);
  }

  throw new Error('Stripe is not ready');
}
